import type { Type } from '@angular/core';
import { ContentChild, Directive, inject } from '@angular/core';

import { TemplateResolver } from '../../../utils/template-resolver';
import { Select2DefaultSearchComponent } from './search-default.component';
import { Select2SearchDirective } from './search.directive';

@Directive({
  standalone: true,
  selector: 'rt-select2-search-resolver',
})
export class SearchResolverDirective extends TemplateResolver<
  Select2SearchDirective,
  { optional: false }
> {
  @ContentChild(Select2SearchDirective)
  public override contentDirective?: Select2SearchDirective;
  public override injectedComponent = <Type<Select2DefaultSearchComponent>>(
    (<unknown>inject(Select2DefaultSearchComponent, { optional: true }))
  );
  public override defaultComponent = Select2DefaultSearchComponent;
}
